<template>
   <div>
    
    
    <Character class="character" />
    
    
   
  </div>
  
</template>

<script>

import Character from './components/Character.vue';


import './assets/tailwind.css'



export default {
  name: 'App',
  components: {
    Character, 
    
    
  },
  created() {
    
  },
  mounted() {
    
  },
  methods: {
   
  }
  
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  background-image: url("./assets/x-1.jpg");
  background-size: contain;
  margin: 0; 
  padding: 0; 
  height: 100vh;
  width: 100%;
  
  
  /* overflow-x: hidden; */
  /* display: grid;
  align-items: center;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr 1fr 1fr;
  gap: 0px 0px;
  grid-auto-flow: row;
  grid-template-areas:
    "title title title title title"
    "characters characters characters characters characters"
    "characters characters characters characters characters"
    "characters characters characters characters characters"
    "characters characters characters characters characters";
  }
  .logo {
  width: 100%;
  grid-area: logo;  */
  display:grid;
  
}


.characters { z-index: 10; }



</style>
.container {  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr 1fr 1fr;
  gap: 0px 0px;
  grid-auto-flow: row;
  grid-template-areas:
    "title title title title title"
    "characters characters characters characters characters"
    "characters characters characters characters characters"
    "characters characters characters characters characters"
    "characters characters characters characters characters";
}

.title { grid-area: title; }

.characters {  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr 1fr;
  gap: 0px 0px;
  grid-auto-flow: row;
  grid-template-areas:
    "tormenta . . . titania"
    "tormenta . coloso . titania"
    ". guepardo coloso ciclope ."
    ". guepardo coloso ciclope .";
  grid-area: characters;
}

.tormenta { grid-area: tormenta; }

.guepardo { grid-area: guepardo; }

.coloso { grid-area: coloso; }

.ciclope { grid-area: ciclope; }

.titania { grid-area: titania; }

